import type { EtapaDoFunil } from "@base/contracts";

export type IdDaConexao = "meta-ads" | "google-ads" | "kommo";

export type SituacaoDaConexao = "nao-conectada" | "conectada" | "sincronizando" | "com-erro";

export type Conexao = {
  readonly id: IdDaConexao;
  readonly nome: string;
  readonly categoria: "Mídia paga" | "CRM";
  readonly descricao: string;
  /** O que esta fonte alimenta no Dashboard. */
  readonly alimenta: readonly string[];
  /** Etapas do funil que dependem desta fonte. */
  readonly etapas: readonly EtapaDoFunil[];
  /** Passos para conectar, mostrados no painel de conexao. */
  readonly passos: readonly string[];
};

/**
 * As fontes de dados do projeto. Meta e Google alimentam a midia (investimento e
 * leads do gerenciador); o Kommo alimenta todo o resto do funil e o financeiro.
 */
export const CONEXOES: readonly Conexao[] = [
  {
    id: "meta-ads",
    nome: "Meta Ads",
    categoria: "Mídia paga",
    descricao: "Campanhas do Facebook e do Instagram.",
    alimenta: ["Investimento", "Leads do gerenciador", "Criativos das oportunidades"],
    etapas: ["gerenciador"],
    passos: [
      "A equipe Monte salva uma vez o token do Business Manager.",
      "Escolher as contas de anúncio desta clínica.",
      "Escolher o que conta como lead (cadastros e/ou conversas).",
    ],
  },
  {
    id: "google-ads",
    nome: "Google Ads",
    categoria: "Mídia paga",
    descricao: "Campanhas de pesquisa, display e YouTube.",
    alimenta: ["Investimento", "Leads do gerenciador", "Criativos das oportunidades"],
    etapas: ["gerenciador"],
    passos: [
      "A equipe Monte entra uma vez com a conta Google (e informa o MCC, se houver).",
      "Escolher as contas de anúncio desta clínica.",
      "O investimento dessas contas entra no Dashboard.",
    ],
  },
  {
    id: "kommo",
    nome: "Kommo CRM",
    categoria: "CRM",
    descricao: "Leads, etapas do funil, propostas e vendas.",
    alimenta: [
      "Etapas CRM, MQL, Agendado, Consulta e Venda",
      "Faturamento, ticket médio e valor em aberto",
      "Ciclo de vendas e leads ativos",
    ],
    etapas: ["crm", "mql", "agendado", "consulta", "venda"],
    passos: [
      "Criar uma integração privada no Kommo e gerar um token de longa duração.",
      "Informar o endereço da conta e o token.",
      "Escolher a etapa do Kommo de cada item do funil.",
    ],
  },
];

export const ROTULO_DA_SITUACAO: Readonly<Record<SituacaoDaConexao, string>> = {
  "nao-conectada": "Não conectada",
  conectada: "Conectada",
  sincronizando: "Sincronizando",
  "com-erro": "Com erro",
};
